import __var_0__ from '@stdlib/vendor/os.js';
import __var_1__ from '@stdlib/assert/is-function';
import __var_2__ from './homedir.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Return the current user's home directory.
*
* @module @stdlib/os/homedir
*
* @example
* var homedir = require( '@stdlib/os/homedir' );
* var home = homedir();
* // e.g., returns '/Users/<username>'
*/

// MODULES //
var os = __var_0__;
var isFunction = __var_1__;
var homedir = __var_2__;


// VARIABLES //

var home = ( isFunction( os.homedir ) ) ? os.homedir : homedir;


// EXPORTS //
export default home;
